import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { attorneysKeys } from 'app/queries/attorneys/attorneysKeys';
import type { TCall } from 'app/queries/types/TCall';
import { buildAttorneysTransactionsRequest } from './buildAttorneysTransactionsRequest';

type TParams = QueryFunctionContext<ReturnType<typeof attorneysKeys.transactionList>>;

export const createFetchAttorneysTransactionsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        OrganizationsService.getAllAttorneysTransactions(buildAttorneysTransactionsRequest(organizationId, params)),
        signal,
      ),
    );
